<template>
  <el-progress
    v-if="percentage"
    :percentage="percentage"
    :size="size"
  />

  <el-tag
    type="danger"
    :size="size"
    effect="plain"
    v-else-if="instance.state === 'terminating' || instance.state === 'shutdown'"
  >
    <i class="el-icon-loading" />
    Waiting for the server shutdown
  </el-tag>

  <el-tag
    type="warning"
    :size="size"
    effect="plain"
    v-else-if="instance.state === 'resizing'"
  >
    <i class="el-icon-loading" />
    Resizing server
  </el-tag>

  <el-tag
    v-else-if="instance.state === 'starting'"
    :size="size"
    type="warning"
    effect="plain"
  >
    <i class="el-icon-loading" />
    Waiting for the server to start
  </el-tag>

  <el-tag
    v-else-if="instance.state === 'pending'"
    :size="size"
    type="danger"
    effect="plain"
  >
    <i class="el-icon-error" />
    No payment method available
  </el-tag>

  <el-tag
    type="primary"
    :size="size"
    effect="plain"
    v-else-if="instance.publicIp"
  >
    <i class="el-icon-magic-stick" />
    Initializing
  </el-tag>

  <el-tag
    v-else-if="instance.providerId"
    :size="size"
    type="warning"
    effect="plain"
  >
    <i class="el-icon-loading" />
    Waiting for the server to start
  </el-tag>

  <el-tag
    v-else
    :size="size"
    type="danger"
    effect="plain"
  >
    <i class="el-icon-search" />
    Checking availability on {{ plan.provider.name }}
  </el-tag>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    instance: Object,
    size: {
      type: String,
      default: 'medium'
    }
  },
  computed: {
    plan () {
      return this.plans.find((p) => p.id === this.instance.planId)
    },
    percentage () {
      return this.task && this.task.progress !== undefined ? parseInt(this.task.progress) : null
    },
    task () {
      return this.tasks.find((t) => t.instanceId === this.instance.id &&
        t.image === 'ansible' && t.running === '1')
    },
    ...mapState(['tasks'])
  }
}
</script>
